var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Dimio Library
 *
 * Ant Plugin
 *
 * Required: antd, moment
 */

import React, { PureComponent, Component } from 'react';
import { Avatar, Button, Card, Form, Input, Icon, List, Menu, Popover, Radio, Rate, Switch, Upload, Row, Col, message } from 'antd';
import moment from 'moment';
import request from 'superagent';
import CanvasCompress from 'canvas-compress';

var Divider = {
  slash: '/'
};

//import Animate from 'react-move/Animate';
//import Formatter from 'formatter';
//import { easeExpOut } from 'd3-ease';
var Dragger = Upload.Dragger;

export var DimioUploader = function DimioUploader(props) {
  var opt = Object.assign({
    multiple: true,
    name: 'file',
    /*
    beforeUpload(file, fileList){
    },
    */
    customRequest: function customRequest(opt) {
      console.info(opt);
      var compressor = new CanvasCompress({
        type: CanvasCompress.MIME.JPEG,
        width: 1920,
        height: 1080,
        quality: 0.8
      });

      compressor.process(opt.file).then(function (_ref) {
        var source = _ref.source,
            result = _ref.result;

        // const { blob, width, height } = source;
        var blob = result.blob,
            width = result.width,
            height = result.height;


        request.post(opt.action).attach('file', blob, opt.file.name).field(opt.data).then(function (res) {
          return opt.onSuccess(res);
        }).catch(function (err) {
          err;
        });
      });
    },
    onChange: function onChange(info) {
      console.info(info);
      if (info.file.status === 'done') {
        var res = info.file.response;
        /*
        if(res.success === true){
        message.success(`${info.file.name} file uploaded successfully`);
        if(options.onSuccess) {
          options.onSuccess(res);
        }
        }else{
          message.error(`${info.file.name} ${res.error}`);
        }
        */
      } else if (info.file.status === 'error') {
        message.error(info.file.name + ' file upload failed.');
      }
    }
  }, props);

  return React.createElement(
    Dragger,
    opt,
    React.createElement(
      'p',
      { className: 'ant-upload-drag-icon' },
      React.createElement(Icon, { type: 'inbox' })
    ),
    React.createElement(
      'p',
      { className: 'ant-upload-text' },
      props.message
    )
  );
};

// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------
export var AtomicImage = function (_PureComponent) {
  _inherits(AtomicImage, _PureComponent);

  function AtomicImage(props) {
    _classCallCheck(this, AtomicImage);

    var _this = _possibleConstructorReturn(this, (AtomicImage.__proto__ || Object.getPrototypeOf(AtomicImage)).call(this, props));

    _this.state = { dimensions: {} };
    _this.onImgLoad = _this.onImgLoad.bind(_this);
    return _this;
  }

  _createClass(AtomicImage, [{
    key: 'onImgLoad',
    value: function onImgLoad(_ref2) {
      var img = _ref2.target;

      this.setState({ dimensions: { height: img.offsetHeight,
          width: img.offsetWidth } });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          src = _props.src,
          _props$className = _props.className,
          className = _props$className === undefined ? '' : _props$className;
      //    const {width, height} = this.state.dimensions;

      return React.createElement('img', { onLoad: this.onImgLoad, src: src, className: className });
    }
  }]);

  return AtomicImage;
}(PureComponent);

/**
 * <ExImage />
 * @param props
 *   url: url - if it's clicked
 *   thumb: url - thumbnail url if images and thumb are both set, thumb is only used
 *   images: [
 *
 *   ]
 */
var ExImage = function ExImage(props) {
  var thumb = props.thumb,
      images = props.images;


  if (thumb) {
    return React.createElement('img', { src: thumb, alt: '', className: 'dimio-thumb img-fluid' });
  } else if (images) {
    images.map(function (image) {
      return React.createElement('img', { src: image, alt: '', className: 'dimio-image img-fluid' });
    });
  } else {
    return null;
  }
};

// ----------------------------------------------------------------------------
// UI
// ----------------------------------------------------------------------------
export var IconText = function IconText(_ref3) {
  var type = _ref3.type,
      text = _ref3.text;
  return React.createElement(
    'span',
    null,
    React.createElement(Icon, { type: type, style: { marginRight: 6 } }),
    text
  );
};

/**
 *
 * @param props
 *   status: boolean login status
 */
/*
export const ButtonLogin = (props) => (
  <Button>{props.children}</Button>
);
*/

export var ButtonMinus = function ButtonMinus(props) {
  return React.createElement(
    Button,
    Object.assign({}, props, { icon: 'minus', type: 'circle' }),
    props.children
  );
};
export var ButtonPlus = function ButtonPlus(props) {
  return React.createElement(
    Button,
    Object.assign({}, props, { icon: 'plus', type: 'circle' }),
    props.children
  );
};

/**
 * <Price currency='$' unit='/mth'>300</Price>
 * @param props
 *   currency: string
 *   unit: string
 *   className: string
 *   precision
 *   decimalSeparator
 */
export var Price = function Price(props) {
  return React.createElement(
    'div',
    { className: 'dimio-price ' + props.className },
    props.prefix,
    props.children,
    React.createElement(
      'span',
      { className: 'dimio-price-currency' },
      props.currency
    ),
    props.unit && React.createElement(
      'span',
      { className: 'dimio-price-unit' },
      '/',
      props.unit
    )
  );
};

/**
 * <Address postcode='2022'>1 Ebley st, Bondi Junction</Address>
 * @param props
 *   postcode: string
 */
export var Address = function Address(props) {
  return React.createElement(
    'div',
    { className: 'dimio-addreess' },
    props.postcode && React.createElement(
      'span',
      { className: 'dimio-addreess-postcode' },
      '\u3012',
      props.postcode
    ),
    React.createElement(
      'address',
      null,
      props.children
    )
  );
};

/**
 * <ExDate date='2018-01-01' format='YYYY/MM/DD' className='ext-date' />
 * @param props
 *   date: string
 *   format: string
 *   className: string
 */
export var ExDate = function ExDate(_ref4) {
  var date = _ref4.date,
      format = _ref4.format,
      _ref4$className = _ref4.className,
      className = _ref4$className === undefined ? '' : _ref4$className;

  var fmt = format ? format : 'YYYY/MM/DD (ddd)';
  return React.createElement(
    'time',
    { className: 'dimio-date ' + className },
    moment(date).format(fmt)
  );
};

/**
 * <ExDate date='2018-01-01' format='YYYY/MM/DD' className='ext-date' />
 * @param props
 *   date: string
 *   format: string
 *   className: string
 */
export var ExRate = function ExRate(_ref5) {
  var rate = _ref5.rate,
      _ref5$className = _ref5.className,
      className = _ref5$className === undefined ? '' : _ref5$className;
  return React.createElement(
    'div',
    { className: 'dimio-rate rate ' + className },
    React.createElement(Rate, { allowHalf: true, disabled: true, defaultValue: parseFloat(rate) })
  );
};

/**
 *
 * <Numeric label={props.label} value={props.value}
 onChange={(value, key) => props.onChange(value, key, ROOMS)}
 icon={<img src='icons/bed2.svg'}/>
 *
 * @param props
 *   label: string - label
 *   value: numeric - defaultValue
 *   icon: object - icon displayed in label section
 *   id:
 *   onChange: event - onChange event
 */
export var Numeric = function (_Component) {
  _inherits(Numeric, _Component);

  function Numeric(props) {
    _classCallCheck(this, Numeric);

    //    console.info(props);

    var _this2 = _possibleConstructorReturn(this, (Numeric.__proto__ || Object.getPrototypeOf(Numeric)).call(this, props));

    _this2.state = {
      value: _this2.props.value ? _this2.props.value : 0
    };

    _this2.plus = _this2.plus.bind(_this2);
    _this2.minus = _this2.minus.bind(_this2);
    _this2.onChange = _this2.onChange.bind(_this2);
    _this2.onBlur = _this2.onBlur.bind(_this2);
    return _this2;
  }

  _createClass(Numeric, [{
    key: 'plus',
    value: function plus() {
      var value = this.state.value;
      //    let value = this.props.value;
      value = value + 1;
      this.setState({ value: value });
      this.props.onChange(value, this.props.id);
    }
  }, {
    key: 'minus',
    value: function minus() {
      var value = this.state.value;
      //    let value = this.props.value;
      value = value > 0 ? value - 1 : 0;
      this.setState({ value: value });
      this.props.onChange(value, this.props.id);
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      e.preventDefault();
      var value = e.target.value;
      this.setState({ value: value });
    }
  }, {
    key: 'onBlur',
    value: function onBlur(e) {
      e.preventDefault();
      //    console.info(e.target.value);
      if (e.target.value.length > 0) {
        this.props.onChange(parseInt(e.target.value), this.props.id);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: '' + this.props.className },
        React.createElement(
          'label',
          { className: 'dimio-numeric-label' },
          this.props.icon && React.createElement(
            'span',
            { className: 'dimio-numeric-icon' },
            this.props.icon
          ),
          React.createElement(
            'span',
            { className: 'title' },
            this.props.label
          )
        ),
        React.createElement(ButtonMinus, { onClick: this.minus, className: 'dimio-numeric-button' }),
        React.createElement(Input
        //          defaultValue={this.props.value}
        , { className: 'dimio-numeric-input text-center'
          //          defaultValue={this.props.value}
          , value: this.state.value,
          onBlur: this.onBlur,
          onChange: this.onChange
        }),
        React.createElement(ButtonPlus, { onClick: this.plus, className: 'dimio-numeric-button' })
      );
    }
  }]);

  return Numeric;
}(Component);

/*
export class DimioSearch extends PureComponent{
  constructor(props) {
    super(props);
    this.state = {
      keyword:false,
      error:false
    };
    this.onSearch = this.onSearch.bind(this);
  }

  onSearch(q, e){
    const {keyword} = this.state;

    if(q.length == 0 && keyword === false) {
      this.setState({error: 'No text'})
    }else{
      if(q.length > 0 && q != keyword){
        // search
        this.setState({keyword: q, error: false});
        this.props.onSearch(q, e);
      }else{
        // reset
        this.setState({keyword: false, error: false});
        this.search.input.input.value = '';
        this.props.onReset();
      }
    }
  }

  render(){
    const {error, keyword} = this.state;

    const errorClass  = error?'dimio-search-error':'';
    const enterButton = keyword?<Icon type="close" theme="outlined" />:<Icon type="search" theme="outlined" />;

    return(
      <Input.Search
        className={`dimio-search ${errorClass}`}
        placeholder={this.props.placeholder?this.props.placeholder:''}
        onSearch={this.onSearch}
        enterButton={enterButton}
        ref={ref => this.search = ref}
      />
    );
  }
}
*/

// ----------------------------------------------------------------------------
// Actions
// ----------------------------------------------------------------------------
/**
 * <UserAction dataIndex={props.id} items={props.actions} onClick={props.onUserAction} />

 * @param props
 *   title,
 *   items:[
 *     {key: '', title:''}
 *   ],
 *   dataIndex: numeric - used as id of the item
 *   onClick: function(item, key, keyPath, dataIndex) -
 */
export var UserAction = function UserAction(props) {
  var title = props.title,
      items = props.items;

  //  console.info(props);

  var content = null;
  if (items) {
    var actionItems = [];
    items.map(function (item) {
      actionItems.push(React.createElement(
        Menu.Item,
        { key: item.key },
        item.title
      ));
    });
    content = React.createElement(
      Menu,
      {
        onClick: function onClick(item, key, keyPath) {
          return props.onClick(item, key, keyPath);
        },
        inlineIndent: 0,
        mode: 'horizontal',
        className: 'dimio-user-action-menu' },
      actionItems
    );
  }

  return React.createElement(
    Popover,
    {
      placement: 'bottomRight',
      title: title,
      content: content,
      overlayClassName: 'dimio-user-action',
      trigger: 'click' },
    React.createElement(Button, { icon: 'ellipsis', type: 'circle' })
  );
};

// ----------------------------------------------------------------------------
// Presentation - Item
// ----------------------------------------------------------------------------
/**
 *
 * <ListItem
 *
 * @param props
 *   key
 *   title
 *   description
 *   actions:[
 *   {key:'', title:'', icon:''}
 *   ]
 *   onUserAction: event
 */
/*
export const ListItem = (props) => {
//  console.info(props);
  return(
    <List.Item
      key={props.id}
      actions={[<UserAction
        items={props.actions}
        onClick={props.onUserAction} />,
        <Button type='circle' icon='eye' onClick={props.onPreview}/>
      ]}
      extra={props.extra}
      onClick={props.onClick}
    >
      <List.Item.Meta
        avatar={props.thumb && <Avatar src={props.thumb}  shape="square" size="large" />}
        title={<a href={props.href}>{props.title}</a>}
        description={
          <div>
            {props.date && <ExDate date={props.date} /> }
            {props.description}
          </div>
        }
      />
      {props.children}
    </List.Item>
  )
};
*/

/**
 *
 * <ExListItem
 *
 * @param props
 *   index(*): key of List Item
 *   actions:[
 *   {key:'', title:'', icon:''}
 *   ]
 *   onUserAction: event
 *
 * Implementation
 *  getItems(item){
 *    return(
 *      <ExListItem
 *      key={item.key}
 *      >
 *         something...
 *      </ExListItem>
 *    );
 *  }
 *
 *
 * <List
 *   itemLayout="vertical"
 *    dataSource={estimations}
 *    renderItem={item => this.getItems(item)}>
 *
 */
export var ExListItem = function ExListItem(props) {
  console.info(props);

  var UserActions = [];
  if (props.actions) {
    props.actions.map(function (action) {
      if (action.type == 'menu') {
        UserActions.push(React.createElement(UserAction, {
          key: action.key,
          items: action.items,
          onClick: action.event }));
      } else if (action.type == 'buttons') {
        var _tmp = [];
        {
          action.items && action.items.map(function (item) {
            _tmp.push(React.createElement(
              Radio.Button,
              {
                size: 'small',
                key: item.key,
                value: item.key },
              item.title
            ));
          });
        }

        UserActions.push(React.createElement(
          Radio.Group,
          { buttonStyle: 'solid', onChange: function onChange(item) {
              console.info(item);action.event(item);
            } },
          _tmp
        ));
      } else if (action.type == 'toggle') {
        var defaultValue = props[action.key] ? props[action.key] : false;

        UserActions.push(React.createElement(Switch, {
          checkedChildren: action.items[0].title,
          unCheckedChildren: action.items[1].title,
          checked: defaultValue,
          onChange: action.event
        }));
      } else if (action.type == 'preview') {
        UserActions.push(React.createElement(Button, { type: 'circle', icon: 'eye', onClick: action.event }));
      } else if (action.type == 'component') {
        UserActions.push(action.component);
      }
    });
  }

  return React.createElement(
    List.Item,
    {
      key: props.index
      //      actions={props.actions}
      , actions: UserActions
      //      extra={props.extra}
      //      onClick={props.onItemClick}
      , onClick: function onClick(e) {
        e.preventDefault();
        if (e.target.type && e.target.type == 'button') {} else {
          if (props.onItemClick) {
            props.onItemClick(props, e);
          }
        }
      }
    },
    props.children
  );
};

/**
 * <CardItem />
 * @param props
 * title
 * thumb
 * rate
 * children
 */
export var ExCardItem = function ExCardItem(props) {
  return React.createElement(
    Card,
    {
      bodyStyle: { padding: 0 },
      className: 'dimio-card ' + props.className,
      onClick: props.onClick
      //      hoverable
      //      title={null}
      //      cover={<img alt="example" src="http://res.cloudinary.com/dimio/image/upload/v1518396929/pexels-photo-271624.jpg" />}
    },
    React.createElement(
      'div',
      { className: 'dimio-card-image' },
      props.url ? React.createElement(
        'a',
        { href: props.url },
        React.createElement(ExImage, props)
      ) : React.createElement(ExImage, props),
      props.overlayImageRight && React.createElement(
        'div',
        { className: 'dimio-card-image-right' },
        props.overlayImageRight
      ),
      props.overlayImageTop && React.createElement(
        'div',
        { className: 'dimio-card-image-top' },
        props.overlayImageTop
      ),
      props.overlayImageRightTop && React.createElement(
        'div',
        { className: 'dimio-card-image-right-top' },
        props.overlayImageRightTop
      ),
      props.overlayImageBottom && React.createElement(
        'div',
        { className: 'dimio-card-image-bottom' },
        props.overlayImageBottom
      ),
      props.actions && React.createElement(
        'div',
        { className: 'dimio-card-image-actions' },
        props.actions
      )
    ),
    props.children && React.createElement(
      'div',
      { className: 'dimio-card-body' },
      React.createElement(
        'h2',
        { className: 'dimio-card-title' },
        props.url ? React.createElement(
          'a',
          { href: props.url },
          props.title
        ) : React.createElement(
          'span',
          null,
          props.title
        )
      ),
      props.children,
      props.actionContent && React.createElement(
        Popover,
        {
          placement: 'bottomRight'
          //          title='Actions'
          , content: props.actionContent,
          overlayClassName: 'popsup-action-controller',
          trigger: 'click' },
        React.createElement(Button, { icon: 'ellipsis', className: 'popsup-action-controller-button' })
      )
    )
  );
};
/*
export const InfoItems = (props) => {
  const {data} = props;

  return(
    data &&
    <Row className='dimio-info'>
      {data.map((item,idx) => (
        <InfoItemA {...item} key={idx} />
      ))}
    </Row>
  )
};

export const InfoItemA = (props) => {
  return(
    <div className='card dimio-info-item p-3 mb-2'>
      <h5 className="dimio-info-item-label">{props.icon && props.icon} {props.label}</h5>
      <div className="dimio-info-item-value">{props.value}</div>
    </div>
  )
};
*/
/*
export class Lang{
  constructor(url, lang){
    request
      .get(url)
      .query({lang: lang})
      .type('json')
      .then (res => {
        this.data = res.body.data;
        console.error(res.body.data);
      })
      .catch(err => {
        console.error(err);
      });
  }
  t(label){
    const {trans} = this.data;
    if(trans){
      return (trans[label])?trans[label]:label;
    }else{
      console.warn("Lang.data is not set");
      return label;
    }
  }
}
*/


//////////////////
// WEBPACK FOOTER
// ./node_modules/dimio/dist/DimioLibrary.js
// module id = 1333
// module chunks = 0